import { JourneyPlan } from '@rtls/core/models/transports/journey-plan.model';
import { random, randomDate, randomName, randomWord } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';

export const journeyPlanFactory = Factory.makeFactory<JourneyPlan>({
	deletedDate: Factory.each(() => randomDate()),
	departureOnFriday: Factory.each(() => random()),
	departureOnMonday: Factory.each(() => random()),
	departureOnSaturday: Factory.each(() => random()),
	departureOnSunday: Factory.each(() => random()),
	departureOnThursday: Factory.each(() => random()),
	departureOnTuesday: Factory.each(() => random()),
	departureOnWednesday: Factory.each(() => random()),
	endDate: Factory.each(() => randomDate()),
	extId: Factory.each(() => randomWord()),
	name: Factory.each(() => randomName()),
	provider: Factory.each(() => randomName()),
	startDate: Factory.each(() => randomDate()),
	uuid: Factory.each((uuid) => uuid.toString()),
});
